 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axios from "../../config/socialaxios";

const apiGetUserNotifications = async (last_notification_id, limit) => {
    try {
        const result = await axios.get(`/notifications`, {
            params: {
                last_notification_id: last_notification_id,
                limit: limit,
            },
        });
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.data]);
    }
};

const apiGetNotificationsCount = async () => {
    try {
        const result = await axios.get(`/notifications/count`);
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _3 => _3.response, 'optionalAccess', _4 => _4.data]);
    }
};

const apiPatchReadNotification = async (payload) => {
    try {
        const result = await axios.patch(`/notifications/read`, payload);
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _5 => _5.response, 'optionalAccess', _6 => _6.data]);
    }
};

export {
    apiGetNotificationsCount,
    apiGetUserNotifications,
    apiPatchReadNotification,
};
